import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'
import { Employee } from 'models'

type Result = {
  _id: string
  password: string
}

type Props = {
  visible: Employee | undefined
  onSave: ({ _id, password }: Result) => void
  onCancel: () => void
}

export const AddNewEmployeeModal = (props: Props) => {
  const [form] = Form.useForm()

  const onFinish = (result: Result) => {
    props.onSave(result)
  }

  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal
      visible={props.visible ? true : false}
      title={`${props.visible?.last_name} ${props.visible?.first_name} | Muuta salasana`}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => {
              props.onCancel()
            }}
            color="default"
          />
          <Button
            label="Tallenna"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {/* _id */}
        <Form.Item name="_id" hidden={true} initialValue={props.visible?._id} rules={[{ required: true, message: 'Anna uusi salasana' }]}>
          <Input />
        </Form.Item>
        {/* password */}
        <Form.Item label={'Salasana'} name="password" rules={[{ required: true, message: 'Anna uusi salasana' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AddNewEmployeeModal
